angular.module('bmsApp.user')
	.controller('LoginCtrl',
		[
			'$scope',
			'$log',
			'AuthService',
			'$rootScope',
			'AUTH_EVENTS',
			'$state',
			'$localStorage',
			'$http',
			function ($scope, $log, AuthService, $rootScope, AUTH_EVENTS, $state, $localStorage, $http) {

				$scope.processing = false;

				$scope.init = function() {
					// $scope.loading = true;
					// AuthService.getUser().then(function (user) {
					// 	if (user) {
					// 		AuthService.redirect();
					// 	}
					// 	else {
					// 		$scope.loading = false;
					// 		angular.element('[name="email"]').focus();
					// 	}
					// });
				};


				$scope.login = function (credentials) {
					$scope.processing = true;
					AuthService.login(credentials)
						.then(function (response) {
							if (!angular.isDefined($localStorage.currentInstance)) {
								if(response.data.franchise.instances.length > 1){
									$state.go('instanceSelection');
								}
								else{
									$localStorage.currentInstance = response.data.franchise.instances[0];
									$http.defaults.headers.common = {'FranchiseInstanceId': $localStorage.currentInstance ? $localStorage.currentInstance.id : ''};
									AuthService.redirect();
								}
							}
							else{
								AuthService.redirect();
							}
						}, function (error) {
							$scope.errors = error;
						})
						.finally(function () {
							$scope.processing = false;
						});
				};

			}
		]);
